const uuidRegEx = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

// A function that takes a path and a dictionary and replaces the dictionary keys in the path with the dictionary values
// Example:
// formatResourcePath('/users/:id', { id: 1 }) => '/users/1'
// formatResourcePath('/parkings/:parkingId/vehicles/:vehicleId', { vehicleId: 3, parkingId: 12 }) => '/parkings/12/vehicles/3'
const formatResourcePath = (path: string, dictionary?: Record<string, string | number>) => {
    const formattedPath = path.split('/').reduce((acc, part) => {
        if (part.startsWith(':') && dictionary) {
            try {
                const dictionaryPart = part.split(':')[1];
                return acc.replace(part, dictionary[dictionaryPart].toString());
            } catch (e) {
                console.error(`Could not replace ${part} in ${path} with dictionary value`);
            }
        }
        return acc;
    }, path);

    return formattedPath;
};

// Since bulgarian license plates contain only of cyrilic letters that have a corresponding latin letter,
// we can transliterate them for the ease of users.
const transliterateUppercase = (text: string) =>
    text
        .replace(/\u0410/g, '\u0041') // A
        .replace(/\u0412/g, '\u0042') // B
        .replace(/\u0415/g, '\u0045') // E
        .replace(/\u041A/g, '\u004B') // K
        .replace(/\u041C/g, '\u004D') // M
        .replace(/\u041D/g, '\u0048') // H
        .replace(/\u041E/g, '\u004F') // O
        .replace(/\u0420/g, '\u0050') // P
        .replace(/\u0421/g, '\u0043') // C
        .replace(/\u0422/g, '\u0054') // T
        .replace(/\u0423/g, '\u0059') // Y
        .replace(/\u0425/g, '\u0058'); // X

export { formatResourcePath, uuidRegEx, transliterateUppercase };
